// extracted by mini-css-extract-plugin
export default {"clickable":"mVNjfCmjweEOK8vGuboN","list":"a6R4zHOd9Gti_SxfDhrJ","title":"qRiYdDVp0zryQYFNI7fw","item":"cWUsqsM_4lvGVrfdRYvV","highlightedItem":"yU6gR_CngZRtFnLlNbjH"};